import { Box, Image, Text, Timer } from '@bonanza-social/moonlight';
import { memo, useCallback } from 'react';
import type { ShopSlotCooldownLabelProps } from './ShopSlotCooldownLabel.types';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { selectStatus } from '@bonanza-social/status';
import { fetchShopSlots } from '../../state';

function ShopSlotCooldownLabel({ cooldownEnd }: ShopSlotCooldownLabelProps) {
  const status = useSelector(selectStatus);
  const dispatch = useDispatch();
  const fetchSlots = useCallback(() => dispatch(fetchShopSlots()), [dispatch]);

  if (!status || !cooldownEnd) {
    return null;
  }

  return (
    <Box
      zIndex={30}
      flexDirection="row"
      alignItems="center"
      gap="space-100"
      variant="gradient"
      gradient={`status${status.playerStatus}Background`}
      paddingHorizontal="space-200"
      paddingVertical="space-100"
      borderRadius="radius-300"
    >
      <Image name="common.DarkClock" width="space-500" height="space-500" />
      <Box flexDirection="row" gap="space-050">
        <Text
          variant="caption"
          color="accentSurfacePrimary"
          locNS="shop"
          locKey="shopPromotionsItemCooldown"
        />
        <Timer
          variant="caption"
          color="accentSurfacePrimary"
          time={cooldownEnd}
          onCountDownComplete={fetchSlots}
        />
      </Box>
    </Box>
  );
}

export default memo(ShopSlotCooldownLabel);
